import setAsyncState from '@functions/setAsyncState.ts';

import I from '../types.ts';

const init: I['init'] = async function () {
    const heights: I['state']['heights'] = {};

    this.questions.forEach((question, key) => {
        const card = this.parent.current!.querySelector(
            `.publicExecutorsFaq__card[data-key="${key}"]`,
        ) as HTMLElement;
        const cardInner = card.querySelector(
            '.publicExecutorsFaq__cardContentInner',
        ) as HTMLElement;
        const { offsetHeight } = cardInner;

        heights[key] = offsetHeight;
    });

    await setAsyncState.call(this, { heights });
};

export default init;
